import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, FormGroup, Label, Input

} from 'reactstrap';
import Isvg from "react-inlinesvg";

import { Link } from 'react-router-dom';

import FormBuilder from '../../components/forms/modalFormBuilder';
import { required } from '../../components/forms/validation';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import moment from 'moment';
import PrintHelper from '../../components/printHelper';

import Search from "../../components/search";
import profileUser from "../../assets/images/user.png";
import notification from "../../assets/svg/notification.svg";
import moreIcon from "../../assets/svg/more.svg";
import Checkbox from '../../components/forms/fields/checkbox';
import openChat from '../../assets/svg/open_chat.svg';

import xIcon from '../../assets/svg/x.svg';



class TransferCaseModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            loadingTransfer: false

        };
    }

    getDoctors = () => {
        const groupId = this.props.selectedGroup;
        const clinicId = this.props.selectedClinic;
        if (groupId && clinicId) {

            this.setState({ doctors: [] }, () => {
                fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        groupId: groupId,
                        clinic: clinicId,
                        query: {},
                    })
                }).then(res => res.json()).then((result) => {
                    if (result?.length)
                        this.setState({ doctors: result })
                })
            })


        }

    }


    componentDidMount() {

        let check = this.checkPermission();
        if (!check) {
            return;
        }

        this.getDoctors();

    }

    toggle = () => {
        if (this.props.toggle) {
            this.props.toggle();
        }
    }
    checkPermission = () => {
        const referral = this.props.referral;
        if (!referral?._id) return false;

        const status = referral?.status;
        const allowedStatuses = ['allowed', 'scheduled', 'visit-rescheduled', 'not-booked', 'revisit-scheduled', 'in-progress'];
        if (!status || (status && allowedStatuses.indexOf(status) === -1)) return false;

        const clinicId = referral?.recipientClinic;
        if (!clinicId || clinicId !== this.props.selectedClinic) return false;

        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const adminPermissionId = this.props.uData?.permissions?.admin;
        const schedulerPermissionId = this.props.uData?.permissions?.scheduler;
        const isAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(schedulerPermissionId) !== -1 ? true : false;

        if (!isAdmin) return false;

        return true;
    }
    getDoctorName = (doctorId) => {
        if (!doctorId) return null
        const doctor = this.state.doctors?.find(el => el._id === doctorId);
        if (!doctor) return null
        return doctor.name;
    }
    getDoctorsList = (currentDoctorId) => {
        let excludeIds = [];
        if (currentDoctorId) excludeIds.push(currentDoctorId);
        if (this.props.patientId) excludeIds.push(this.props.patientId);

        let doctors = this.state.doctors?.filter(el => excludeIds.indexOf(el._id) === -1);
        if (!doctors?.length) return [];

        return doctors.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }
        }).map((item, idx) => {
            return {
                value: item._id,
                label: item.name
            }
        })
    }
    getEventForCase = async (referralId) => {
        if (!referralId) return null;

        let response = await fetch(API_ENDPOINT + '/working-hours/events/referral/' + referralId, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        });
        let result = await response.json();
        if (result?.event) {
            return result.event;
        } else {
            return null;
        }
    }
    transferFetch = (api, data, otherData) => {
        this.setState({
            loadingTransfer: true
        }, () => {
            fetch(API_ENDPOINT + api, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    if (result.error == 'Event can not start or end while others are in progress!') {
                        this.setState({
                            errorOverlap: {
                                message: 'Unable to transfer this case to a new caregiver. The term is not available.'.translate(this.props.lang),
                                doctor: otherData?.referral?.recipientUser,
                                date: otherData?.event?.startTime
                            },
                            loadingTransfer: false
                        })
                    } else {
                        this.handleError(result.error)
                        this.setState({
                            loadingTransfer: false
                        })
                    }
                } else {
                    this.finishedTransfer(result);
                    this.setState({
                        selectedDoctor: -1,
                        loadingTransfer: false
                    })
                }
            })
        })
    }
    transferCase = async () => {
        if (this.state.loadingTransfer) return;

        const referral = this.props.referral;
        const selectedDoctor = this.state.selectedDoctor;
        if (!referral?._id || !selectedDoctor) return;

        const status = referral?.status;
        const scheduledStatuses = ['scheduled', 'visit-rescheduled', 'revisit-scheduled'];
        const isDropIn = referral?.isDropIn;

        let data = {
            doctor: selectedDoctor,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic
        }
        if (isDropIn) {
            data.prevDoctor = referral.recipientUser;
            this.transferFetch(`/referrals/transfer/drop-in/${referral._id}`, data, { referral });

        } else if (scheduledStatuses.indexOf(status) !== -1) {
            let event = await this.getEventForCase(referral?.control ?? referral._id);
            if (event) {
                let date, startTime, endTime, eventId;
                if (event.date) {
                    date = event.date;
                }
                if (event.startTimeString) {
                    startTime = event.startTimeString;
                }
                if (event.endTimeString) {
                    endTime = event.endTimeString;
                }
                if (event._id) {
                    eventId = event._id;
                }
                if (date && startTime && endTime) {
                    data.startEventReservedDateOriginal = date + ' ' + startTime;
                    data.endEventReservedDateOriginal = date + ' ' + endTime;
                    data.startEventReservedDate = this.props.getStringDateInverseTs(Math.floor(new Date(date + ' ' + startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`);
                    data.endEventReservedDate = this.props.getStringDateInverseTs(Math.floor(new Date(date + ' ' + endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`);
                }

                if (eventId && data.startEventReservedDate && data.endEventReservedDate) {
                    this.transferFetch(`/referrals/transfer/${eventId}`, data, { referral, event });
                }
            }
        } else {
            data.prevDoctor = referral.recipientUser;
            data.transferType = 'bookingByClinic';

            this.transferFetch(`/referrals/transfer/drop-in/${referral._id}`, data, { referral });
        }

    }
    finishedTransfer = () => {
        const isDropIn = this.props.referral?.isDropIn;
        if (this.props.onTransfer) {
            this.props.onTransfer(isDropIn);
        }
        this.toggle();
    }
    handleError = (error) => {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    render() {
        let check = this.checkPermission();
        if (!check) {
            return null;
        }
        let currentDoctorName = this.getDoctorName(this.props.referral?.recipientUser);
        let transferFrom = currentDoctorName ?? 'Unassigned'.translate(this.props.lang);

        const transferToList = this.getDoctorsList(this.props.referral?.recipientUser);

        const selectedDoctor = this.state.selectedDoctor && this.state.selectedDoctor !== -1 ? this.state.selectedDoctor : null;


        if (this.state.errorOverlap) {
            return <Modal isOpen={this.state.errorOverlap} centered>
                <ModalBody className="delete-modal">
                    <div className="message">
                        {this.state.errorOverlap && this.state.errorOverlap.message}
                    </div>
                </ModalBody>
                <ModalFooter style={{ display: 'flex', justifyContent: 'center' }} className="buttons-right-blue">
                    <Button style={{ minWidth: 100 }} color="primary" onClick={() => {
                        console.log(this.state.errorOverlap)
                        this.props[0].history.push({
                            pathname: '/my-data/referrals/schedule',
                            search: '?fromAllCases=true',
                            state: {
                                doctor: this.state.errorOverlap && this.state.errorOverlap.doctor,
                                day: new Date((this.state.errorOverlap && this.state.errorOverlap.date) * 1000),
                                step: 5,
                                referralToOpen: this.state.errorOverlap?.referral
                            }
                        })
                    }} >{'Manage in calender'.translate(this.props.lang)}</Button>
                    <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.setState({ errorOverlap: null })} >{'Close'.translate(this.props.lang)}</Button>{' '}
                </ModalFooter>
            </Modal>

        } else {
            return (
                <Modal
                    isOpen={this.props.isOpen}
                    centered
                >
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}><Isvg src={xIcon} /></button>}
                    >
                        <h4>{'Transfer modal'.translate(this.props.lang)}</h4>
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>{'Transfer from'.translate(this.props.lang)}</Label>
                            <Input
                                type='text'
                                disabled
                                value={transferFrom}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>{'Transfer to'.translate(this.props.lang)}</Label>
                            <Input
                                type='select'
                                value={selectedDoctor}
                                onChange={(e) => {
                                    this.setState({ selectedDoctor: e.target.value })
                                }}
                            >
                                <option value={-1}>{'None'.translate(this.props.lang)}</option>
                                {
                                    transferToList.map((item, idx) => {
                                        return (
                                            <option value={item.value}>{item.label}</option>
                                        )
                                    })
                                }

                            </Input>
                        </FormGroup>

                    </ModalBody>
                    <ModalFooter className='buttons-right-blue'>
                        <Button
                            color="primary"
                            disabled={!selectedDoctor || this.state.loadingTransfer ? true : false}
                            onClick={() => {
                                this.transferCase(this.state.transferModal)
                            }}
                        >
                            {'Transfer'.translate(this.props.lang)}
                        </Button>

                        <Button
                            color="primary"
                            onClick={() => this.toggle()}
                        >
                            {'Close'.translate(this.props.lang)}
                        </Button>

                    </ModalFooter>
                </Modal>
            );
        }



    }


}


export default TransferCaseModal